<script>
import DayJourney from '../../common/DayJourney'
import { mostCommon } from '../../../utils'

export default {
  extends: DayJourney,
  props: {
    dj: {'default': () => ({journey: {name: 'Escolher', color: 'success'}})}
  },
  computed: {
    lineSelected () { return true },
    className () {
      return `DayJourney-'Autocomplete'`
    },
    processing () { return false },
    matchJourneySearch () {
      const defaultJourney = this.$store.state.Sheet.currentSheet.rows.find(r => r.dayJourney).dayJourney.journey

      if (!this.search) {
        // return the most common journey not folga

        const journeysTrabalho = this.$store.state.Sheet.currentSheet.rows
          .map(i => i.dayJourney.journey)
          .filter(i => i.kind === 0)

        const journey = mostCommon(journeysTrabalho.map(i => i.id))

        if (journey) {
          return journeysTrabalho.find(i => i.id === journey)
        } else if (journeysTrabalho.length) {
          return journeysTrabalho[0]
        } else {
          return defaultJourney
        }
      } else {
        return this.$store.getters['matchJourneySearch'] || defaultJourney
      }
    }
  },
  methods: {
    keyEvent (e) {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'j') {
        e.preventDefault()
        e.stopPropagation()
        this.activeModal()
      }
    },
    activeModal () {
      this.$modal.show('journey-picker', {
        callback: this.saveDayJourney
      })
    },
    nextDj () {},
    prevDj () {},
    saveDayJourney (journey) {
      this.$modal.hide('journey-picker')
      this.$store.dispatch('autoCompleteDayJourneys', journey)
      this.editing = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// DayJourneyComplete.vue?181ade00